import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e95a2a3e&scoped=true&"
import script from "./composition.js?vue&type=script&lang=js&"
export * from "./composition.js?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&id=e95a2a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95a2a3e",
  null
  
)

export default component.exports